
import { Injectable, Inject, InjectionToken, Optional } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export const GTM_ID = new InjectionToken<string>('GTM_ID');

declare global { interface Window { dataLayer: any[] } }

@Injectable({ providedIn: 'root' })
export class GtmLoaderService {
    private loaded = false;
    constructor(@Inject(DOCUMENT) private doc: Document, @Optional() @Inject(GTM_ID) private gtmId?: string) {}

    start(id?: string) {
        const containerId = id || this.gtmId;
        if (!containerId || this.loaded) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

        const s = this.doc.createElement('script');
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
        this.doc.head.appendChild(s);
        this.loaded = true;
    }
}
